import React from 'react';
import styles from './SalesReport.module.scss';
import { Col, Container, Row } from 'reactstrap';
import DataTable from 'react-data-table-component';
import FilterInTable from '../../../../Manage/FilterInTable';

const currentStatus = [
  { label: "Total Sales", value: "$25,000" },
  { label: "Units Sold", value: "600" },
  { label: "Average Order Value (AOV)", value: "$33.33" },
  { label: "Total Returns", value: "3" },
  { label: "Best-selling Product", value: "Blue Headphones" },
  { label: "Best-selling Category", value: "Electronics" },
];

const salesData = [
  {
    id: 1,
    orderId: 'SHIP-001',
    customerName: 'John Deep',
    orderDate: '11/07/2024',
    lastUpdate: '12/07/2024',
    status: 'Delivered',
    pnfOccurrence: 'No',
  },
  {
    id: 2,
    orderId: 'SHIP-001',
    customerName: 'John Deep',
    orderDate: '11/07/2024',
    lastUpdate: '12/07/2024',
    status: 'Delivered',
    pnfOccurrence: 'No',
  },
  {
    id: 3,
    orderId: 'SHIP-001',
    customerName: 'John Deep',
    orderDate: '11/07/2024',
    lastUpdate: '12/07/2024',
    status: 'Delivered',
    pnfOccurrence: 'No',
  },
  {
    id: 4,
    orderId: 'SHIP-001',
    customerName: 'John Deep',
    orderDate: '11/07/2024',
    lastUpdate: '12/07/2024',
    status: 'Delivered',
    pnfOccurrence: 'No',
  },
  {
    id: 5,
    orderId: 'SHIP-001',
    customerName: 'John Deep',
    orderDate: '11/07/2024',
    lastUpdate: '12/07/2024',
    status: 'Delivered',
    pnfOccurrence: 'No',
  },
];

const salesColumns = [
  {
    name: 'Order ID',
    selector: (row) => row.orderId,
    sortable: true,
    minWidth: "180px",
  },
  {
    name: 'Customer name',
    selector: (row) => row.customerName,
    sortable: true,
    minWidth: "220px",
  },
  {
    name: 'Order date',
    selector: (row) => row.orderDate,
    sortable: true,
    minWidth: "180px",
  },
  {
    name: 'Last Update',
    selector: (row) => row.lastUpdate,
    sortable: true,
    minWidth: "180px",
  },
  {
    name: 'Status',
    cell: (row) => (
      <span className={getStatusClass(row.status)}>{row.status}</span>
    ),
    sortable: true,
    minWidth: "140px",
  },
  {
    name: 'PNF Occurrence',
    selector: (row) => row.pnfOccurrence,
    sortable: true,
    minWidth: "220px",
  },
];

const getStatusClass = (status) => {
  switch (status.toLowerCase()) {
    case 'delivered':
      return styles.statusDelivered;
    default:
      return '';
  }
};

const customStyles = {
  headRow: {
    style: {
      backgroundColor: '#FBBD34',
      color: '#FFFFFF',
      fontSize: '16px',
      fontWeight: '600',
      borderBottom: 'none',
    },
  },
  headCells: {
    style: {
      paddingLeft: "40px",
      paddingRight: "20px",
      div: {
        whiteSpace: "normal",
        overflow: "visible",
      },
    },
  },
  cells: {
    style: {
      fontSize: '15px',
      padding: '15px 20px 15px 40px',
      div: {
        whiteSpace: "normal !important",
        overflow: "visible !important",
      },
    },
  },
};

const monthlyData = [
  {
    id: 1,
    month: 'January',
    sales: '$40,000',
    orders: 400,
    aov: '$115',
    returns: 10,
  },
  {
    id: 2,
    month: 'February',
    sales: '$45,000',
    orders: 410,
    aov: '$125',
    returns: 8,
  },
  {
    id: 3,
    month: 'March',
    sales: '$50,000',
    orders: 430,
    aov: '$135',
    returns: 5,
  },
  {
    id: 4,
    month: 'April',
    sales: '$55,000',
    orders: 450,
    aov: '$150',
    returns: 5,
  },
  {
    id: 5,
    month: 'May',
    sales: '$60,000',
    orders: 470,
    aov: '$180',
    returns: 3,
  },
];

const monthlyColumns = [
  {
    name: 'Month',
    selector: (row) => row.month,
    sortable: true,
    minWidth: "140px",
  },
  {
    name: 'Sales',
    selector: (row) => row.sales,
    sortable: true,
    minWidth: "140px",
  },
  {
    name: 'Orders',
    selector: (row) => row.orders,
    sortable: true,
    minWidth: "140px",
  },
  {
    name: 'Average Order Value',
    selector: (row) => row.aov,
    sortable: true,
    minWidth: "250px",
  },
  {
    name: 'Returns',
    selector: (row) => row.returns,
    sortable: true,
    minWidth: "160px", 
  },
];

const SalesReport = () => {
  return (
    <div className={styles.mainContainer}>
      <h4 className={styles.sectionHeading}>Sales Report</h4>

      <h5 className={styles.subSectionHeading}>Current Status</h5>
      <Row className={styles.currentStatusRow}>
        <Col lg={9} xxl={6} className={styles.statusColumn}>
          {currentStatus.map((status, index) => (
            <Row key={index - `${status.label}`} className={styles.statusContentRow}>
              <Col sm={8} lg={6} className="pe-2">{status.label}:</Col>
              <Col sm={4} lg={6} className={styles.valueColumn}>{status.value}</Col>
            </Row>
          ))}
        </Col>
      </Row>

      <h5 className={styles.subSectionHeading}>Live Sales Report</h5>
      <Container fluid className={styles.filterTableContainer}>
        <FilterInTable componentName={"Sales Report"} />
        <div className={styles.table}>
          <DataTable
            columns={salesColumns}
            data={salesData}
            pagination
            highlightOnHover
            customStyles={customStyles}
          />
        </div>
      </Container>

      <h5 className={styles.subSectionHeading}>Monthly Sales Report</h5>
      <Container fluid className={styles.monthlySalesContainer}>
        <DataTable
          columns={monthlyColumns}
          data={monthlyData}
          highlightOnHover
          customStyles={customStyles}
        />
      </Container>
    </div>
  )
}

export default SalesReport;